import store from '@/store'
const overallSituation = function (val) {
  if (store.state && store.state.overall.length) {
    const hasPermissions = store.state.overall.some((res) => {
      if (res.dictCode == val) {
        return res.dictValue == 1
      }
    })

    return hasPermissions
  } else {
    return false
  }
}

export default overallSituation
// 权限管理。全局设置按钮//之前用自定义指令，懒得改文件了，凑合看把



// WEBPACK FOOTER //
// ./src/directive/overallSituation.js